import { useCallback } from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import {
  BillableShippedGridContext,
  BillableShippedRow,
} from '../utils/columnDefs';

export const BillableShippedLockRenderer = (
  params: ICellRendererParams<BillableShippedRow>,
) => {
  const { t } = useTranslation();
  const context = params.context as BillableShippedGridContext;
  const isVerified = params.data?.verified ?? false;
  const fertilizationId = params.data?.fertilizationId ?? '';
  const isUnlocked = context.unlockedIds?.has(fertilizationId) ?? false;

  const handleClick = useCallback(() => {
    if (isVerified) return;
    context.onLockToggle?.(fertilizationId);
  }, [context, fertilizationId, isVerified]);

  return (
    <Button
      icon={`pi ${isUnlocked ? 'pi-lock-open' : 'pi-lock'}`}
      onClick={handleClick}
      className="p-button-text p-button-plain p-button-sm h-6 w-8 !border-none !shadow-none"
      tooltip={
        isVerified
          ? t('billableShipped.unverifyBeforeOverriding')
          : isUnlocked
            ? t('billableShipped.lockBillableShipped')
            : t('billableShipped.unlockBillableShipped')
      }
    />
  );
};
